import React from 'react';
import { DefaultOption } from 'src/components/molecules/DropdownSelect/components/DropdownOptions';
import { renderDropdownField } from './shared';
import { BaseInputProps } from './types';

export const DropdownMultiInput: React.FC<BaseInputProps> = ({
  currentQuestion,
  answers,
  dispatch,
  dropdownPlaceholder,
}) => {
  const multiDropdownOptions =
    currentQuestion?.options?.map((opt) => ({
      label: opt.text,
      value: opt.id,
    })) || [];

  return renderDropdownField({
    options: multiDropdownOptions,
    value: answers[currentQuestion.id]?.multiDropdownOptions || [],
    onChange: (value) =>
      dispatch({
        type: 'SET_MULTI_DROPDOWN',
        questionId: currentQuestion.id,
        payload: value as DefaultOption[],
      }),
    placeholder: dropdownPlaceholder,
    isMulti: true,
    testId: 'form-preview-dropdown-multi',
  });
};
